/**
 * Build a WhatsApp deep-link (wa.me) for the given mobile number.
 * - Strips non-digits
 * - Prepends country code 91 (India) if not present and length is 10
 * - Returns null when no usable number
 *
 * Optional `text` is URL-encoded into the message field.
 */
export function buildWhatsAppLink(mobile, text = "") {
  if (!mobile) return null;
  let digits = String(mobile).replace(/[^0-9]/g, "");
  if (!digits) return null;
  if (digits.length === 10) digits = "91" + digits;
  const url = `https://wa.me/${digits}`;
  return text ? `${url}?text=${encodeURIComponent(text)}` : url;
}
